import { render, staticRenderFns } from "./ShareInfo.vue?vue&type=template&id=f3067a28&scoped=true&"
import script from "./ShareInfo.vue?vue&type=script&lang=js&"
export * from "./ShareInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShareInfo.vue?vue&type=style&index=0&id=f3067a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3067a28",
  null
  
)

export default component.exports